const pointAt=(positions,index)=>({x:positions[index],y:positions[index+1],z:positions[index+2]});
const distance2=(a,b)=>(a.x-b.x)**2+(a.y-b.y)**2;

function segmentForFeature(positions,feature){
  const offset=feature.start*6;
  return [pointAt(positions,offset),pointAt(positions,offset+3)];
}

function pathForFeature(positions,feature){
  const path=[];
  for(let i=0;i<feature.count;i++){
    const offset=(feature.start+i)*6;
    if(!i)path.push(pointAt(positions,offset));
    path.push(pointAt(positions,offset+3));
  }
  return path;
}

export function polygonAreaFromPath(path){
  if(path.length<4)return 0;
  let sum=0;for(let i=0;i<path.length-1;i++)sum+=path[i].x*path[i+1].y-path[i+1].x*path[i].y;
  return Math.abs(sum)/2;
}

export function selectionForFeature(positions,features,feature,tolerance=.02){
  const tolerance2=tolerance*tolerance;
  if(feature.type!=='LINE'||feature.count!==1){
    const path=pathForFeature(positions,feature),closed=!!feature.closed||path.length>3&&distance2(path[0],path.at(-1))<=tolerance2;
    return{positions:positions.slice(feature.start*6,(feature.start+feature.count)*6),features:[feature],path,closed,area:closed?polygonAreaFromPath(path):0,length2d:feature.length2d,segmentCount:feature.count};
  }

  const candidates=features.filter(item=>item.type==='LINE'&&item.count===1&&item.layer===feature.layer),used=new Set([feature.start]),selected=[feature];
  const [first,last]=segmentForFeature(positions,feature),path=[first,last];
  let extended=true;
  while(extended&&!(path.length>3&&distance2(path[0],path.at(-1))<=tolerance2)){
    extended=false;
    for(const candidate of candidates){
      if(used.has(candidate.start))continue;const [a,b]=segmentForFeature(positions,candidate),head=path[0],tail=path.at(-1);
      if(distance2(a,tail)<=tolerance2){path.push(b);}
      else if(distance2(b,tail)<=tolerance2){path.push(a);}
      else if(distance2(b,head)<=tolerance2){path.unshift(a);}
      else if(distance2(a,head)<=tolerance2){path.unshift(b);}
      else continue;
      used.add(candidate.start);selected.push(candidate);extended=true;break;
    }
  }
  const closed=path.length>3&&distance2(path[0],path.at(-1))<=tolerance2,highlight=[];
  for(let i=1;i<path.length;i++)highlight.push(path[i-1].x,path[i-1].y,path[i-1].z,path[i].x,path[i].y,path[i].z);
  return{positions:new Float32Array(highlight),features:selected,path,closed,area:closed?polygonAreaFromPath(path):0,length2d:selected.reduce((sum,item)=>sum+item.length2d,0),segmentCount:selected.length};
}
